import {
  Button,
  Popover,
  TextInputWithIcon,
} from '@lightspeed/design-system-react'
import { T } from '@transifex/react'
import React, { FormEvent, FunctionComponent, useState } from 'react'
import { useSaleManager } from '../../../../ng-compat/hooks'
import { PROMO_CODE_STATUES } from '../../../promotions/promotions.constant'
import { useAppDispatch, useAppSelector } from '../../../../state/hooks'
import {
  selectSalePromoCodeStatus,
  setPromoCode,
} from '../../../../state/slices/currentSale/currentSaleSlice'
import { PromoCodeError } from './PromoCodeError'

type Props = {
  closePopover: () => void
  openPromoModal: () => void
}

export const AddPromoCodePopover: FunctionComponent<Props> = ({
  closePopover,
  openPromoModal,
}) => {
  const [potentialPromoCode, setPotentialPromoCode] = useState('')
  const [hasError, setHasError] = useState(false)
  const saleManager = useSaleManager()
  const dispatch = useAppDispatch()
  const promoCodeStatus = useAppSelector(selectSalePromoCodeStatus)

  const handlePromoCodeInputChange = (input: string) => {
    setHasError(false)
    setPotentialPromoCode(input)
  }

  const addPromoCode = async (event: FormEvent) => {
    event.preventDefault()

    const newCodeStatus = await saleManager.addOrRemovePromoCode(
      potentialPromoCode
    )
    if (newCodeStatus === PROMO_CODE_STATUES.APPLIED) {
      closePopover()
      return
    }

    dispatch(setPromoCode(''))
    setHasError(true)
  }

  return (
    <Popover
      onClose={closePopover}
      className="sale-popover wr-discount-popover"
    >
      <h1 className="vd-text-label">
        <T _str="Add promo code" _context="Add promo code label" />
      </h1>
      <hr className="vd-hr" />

      <form onSubmit={addPromoCode}>
        <div>
          <TextInputWithIcon
            icon="fa fa-key"
            autoFocus={true}
            value={potentialPromoCode}
            onChange={e => {
              handlePromoCodeInputChange(e.currentTarget.value)
            }}
            hasError={hasError}
          />

          {hasError && (
            <PromoCodeError
              promoCodeStatus={promoCodeStatus}
              openPromoModal={openPromoModal}
            />
          )}
        </div>

        <div className="vd-flex wr-discount-popover-footer vd-pt3 vd-pb3">
          <div className="vd-btn-group">
            <Button variant="supplementary" onClick={closePopover}>
              <T _str="Cancel" _context="Add promo code cancel button" />
            </Button>
            <Button
              variant="go"
              type="submit"
              disabled={!potentialPromoCode || hasError}
            >
              <T _str="Add" _context="Add promo code add button" />
            </Button>
          </div>
        </div>
      </form>
    </Popover>
  )
}
